angular.module('jv.moveCandidate.controller', [])
    .controller('jvMoveCandidateController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','$q', '$window', 'jvHireUrlService','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,$q, $window, jvHireUrlService,jvHireBroadcastSVC) {
            //Used to track if the user is on the candidate list page or details page
            $scope.CandidateListPage = false;
            $scope.CandidateDetailsPage = false;
        
            jvHireBroadcastSVC.subscribe('showMoveCandidateModal', function(event, data) {
                $scope.modalData = angular.extend(data);
                if($scope.appDetails && $scope.applicationId || $scope.params.applicationId){
                    $scope.CandidateDetailsPage = true;
                    $scope.CandidateListPage = false;
                }else{
                    $scope.CandidateDetailsPage = false;
                    $scope.CandidateListPage = true;

                }
                if(JV.Person && JV.Person.Global){
                    JV.Person.Global.grid.showLoadingState();
                }
                
                if($scope.CandidateListPage) {
                    var postData = {
                            data: $scope.modalData.appIds,
                            action: 'moveCandidate'
                    };
                    jvCandidatesService.validateCandidateDetails(postData, function(res) {
                        if (res.status !== 200 || !res.data) {
                            $scope.flags.loading = false;
                            return;
                        }

                        if(res.data.validApplicationIds.length === 0) {
                            var actionValidation = {};
                            actionValidation.show = true;
                            actionValidation.title = i18n.CANDIDATES_MOVE_CANDIDATE_TO_REQ;
                            actionValidation.message = i18n.CANDIDATES_MOVE_PERMISSION_MSG;
                            $rootScope.$emit('actionValidation', actionValidation);
                            return;
                        }
                        $scope.modalData.validationResult = res.data;
                        $scope.modalData.moveAcrossDiffWorkflows = res.data.moveAcrossDiffWorkflows;
                        $scope.modalData.appIds = $scope.modalData.validationResult.validApplicationIds;
                        var message = {};
                           message.text = i18n.CANDIDATES_MOVE_MSG;
                           $scope.modalData.validationResult.message = message;
                        $scope.showModals('move',data);
                    });
                } else {
                    $scope.showModals('move',data);
                }
                
            });

            $scope.duplicateModal = {};
            var showDuplicateModal = function(data){
                $scope.duplicateModal.duplicateItems = data.notmoved;
                $scope.duplicateModal.successCount = data.count;
                $scope.duplicateModal.duplicateCount = $rootScope.size(data.notmoved);
                $scope.duplicateModal.modalTitle = $scope.duplicateModal.duplicateCount >1 ?  i18n['DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_MULTIPLE'] : i18n['DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_SINGLE'];
                $scope.duplicateModal.tableTitle = i18n['DUPLICATE_CANDIDATES_MOVED_TABLE_TITLE'];
                $scope.showModals('duplicateCandidates');
            };
            var i18n;
            if($.isEmptyObject($scope.i18n)){
                //Candidate list page does not have i18n
                i18n = {
                    REQUISITION: 'Requisition',
                    STATUS: 'Status',
                    COMPANY: 'Company',
                    CATEGORY: 'Category',
                    LOCATION: 'Location',
                    MOVE: 'Move',
                    SEARCH: 'Search',
                    ID: 'ID',
                    LIST_MODAL_TEXT: 'Select a Requisition',
                    ALL: 'All',
                    ADD: 'Add',
                    OPEN: 'Open',
                    MODAL_TOOLTIP_TEXT: 'Jobs listed are limited to active and those with the same workflow.',
                    MODAL_VALIDATION_TEXT: 'Please select a requisition',
                    DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_SINGLE:'Move Candidate to Requisition',
                    DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_MULTIPLE:'Move Candidates to Requisition',
                    DUPLICATE_CANDIDATES_MOVED_TABLE_TITLE:'Not Moved to Requisition'
                };
            }else{
                i18n = angular.copy($scope.i18n);
            }

            // Modal Information
            $scope.modals = {
                move: {
                    show: false
                },
                duplicateCandidates:{
                    show:false
                }
            };
            //Setting up different modal configs//
            var defaultToOption = '{"key":"1","mine":true,"name":"My Open"}';
            var getmodalConfig = function(action){
                switch (action) {
                        case 'move':
                        //Move candidate modal config
                        $scope.moveModalConfig = {
                            resetModalOn:'modals.move.show',
                            list: {
                                config: {
                                    type: 'singleSelect',
                                    required: true,
                                    errorText:i18n['MODAL_VALIDATION_TEXT'],
                                    keyName: 'selectedReqEId',
                                    label: i18n['LIST_MODAL_TEXT'],
                                    tooltip: {
                                        show: true,
                                        text: i18n['CANDIDATES_HIRING_MANAGER_NOTIFIED']
                                    },
                                    columns: [
                                        {
                                            header: i18n['REQUISITION'],
                                            show: true,
                                            key: ['title'],
                                            ellipsis: {
                                                set: true
                                            }
                                        },
                                        {
                                            header: i18n['ID'],
                                            show: true,
                                            key: ['requisitionId'],
                                            ellipsis: {
                                                set: true
                                            }
                                        },
                                        {
                                            header: i18n['STATUS'],
                                            show: true,
                                            key: ['jobState']
                                        },
                                        {
                                            header: i18n['COMPANY'],
                                            show: 'showCompany',
                                            key: ['subsidiary.name']
                                        },
                                        {
                                            header: i18n['CATEGORY'],
                                            show: true,
                                            key: ['category.name'],
                                            ellipsis: {
                                                set: true
                                            }
                                        },
                                        {
                                            header: i18n['LOCATION'],
                                            show: true,
                                            key: ['location.name'],
                                            ellipsis: {
                                                set: true
                                            },
                                            tooltipShow: 'jobLocations',
                                            tooltipTriggerLength: 'jobLocations',
                                            tooltipTriggerClass:'italic',
                                            tooltipBodyList: 'jobLocations',
                                            tooltipBodyListId: ['name']
                                        }
                                    ]
                                },
                                get: {
                                    url:$scope.listUrl,
                                    params:$scope.listParamsObj,
                                    responseKey: 'jobs'
                                },
                                post:{
                                    callBack: $scope.moveCandidate,
                                    button: {
                                        label: i18n['MOVE'],
                                        type: 'button',
                                        classNames:['blue-btn','float-right'],
                                        id:'move-btn'
                                    }
                                },
                                filters: [{
                                        label: i18n['STATUS'],
                                        ghostText: i18n['ALL'],
                                        width:'w175',
                                        allowClear: $scope.statusFilterCondition,
                                        data: $scope.statusFilter,
                                        keyName: 'reqsStatusFilter',
                                        defaultTo: defaultToOption
                                    },
                                    {
                                        label: i18n['CATEGORY'],
                                        ghostText: i18n['ALL'],
                                        width:'w260',
                                        allowClear: true,
                                        data:$scope.categoryFilter,
                                        keyName: 'reqsCategoryFilter',
                                        responseKey: 'filters.Categories'
                                    }
                                ],
                                search : {
                                    label: i18n['SEARCH'],
                                    placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                                    get:{
                                        url: $scope.listUrl,
                                        params: $scope.searchParamsObj
                                    }
                                }
                            }
                    };
                    return $scope.moveModalConfig;
                }
            };

            //Function to set up form template config. Making sure this is fired after we get workflowEId back from get appdetails call 
            var setupFormTemplateConfig = function(action, data){
                    //FormTemplateConfig
                    if($scope.CandidateDetailsPage){
                        //details page 
                        $scope.listUrl = '/jhire/action/requisitions?';
                        $scope.listParamsObj = {
                            page:'0',
                            q:'',
                            maxResults:'10',
                            mine:false,
                            workflowId: $scope.workflowEId||0
                        };
                        $scope.searchParamsObj = {
                            workflowId: $scope.workflowEId||0
                        };
                        if($scope.properties.enableMoveCandidate){
                            delete $scope.searchParamsObj.workflowId;
                            delete $scope.listParamsObj.workflowId;
                        }
                    }else{
                        //candidate list page 
                        var jobEId = '';
                        if(data && data.reqId){
                            jobEId = data.reqId;
                        }else{
                            jobEId = JV.Person.getUniqueSelectedApplicationJobIds()[0];
                        }
                        if($scope.properties.enableMoveCandidate){
                            $scope.listUrl = '/jhire/action/requisitions?';
                        }
                        else{
                            $scope.listUrl = '/jhire/action/requisitions/'+jobEId+'/relatedByWorkflow?';
                        }
                        $scope.listParamsObj = {
                            page:'0',
                            q:'',
                            maxResults:'10',
                            mine:false
                        };
                        $scope.searchParamsObj = {};
                    }
                    $scope.formTemplateConfig = getmodalConfig(action);
            };

            //used to fetch the requition filter values
            var fetchFilters = function(){
                var deferred = $q.defer();
                jvCandidatesService.getRequistionFilters(null,function(response){
                    if(response.status === 200 && response.data){
                        deferred.resolve(response.data);
                        $scope.categoryFilter = response.data.filters.Categories;
                        $scope.statusFilter = response.data.statusFilter.optionValues;
                        if(!response.data.statusFilter.hideAllFilter){
                            $scope.statusFilterCondition = true;
                        }else{
                            $scope.statusFilterCondition = false;
                        }
                        angular.forEach($scope.statusFilter,function(value,key){
                            value.key = JSON.stringify(value.key);
                            if(value.key == 1 && value.mine){
                                defaultToOption = JSON.stringify(value);
                            }
                        });
                    }
                });
                return deferred.promise;
            };

            //Used to show the move modal
            $scope.showModals = function(modal,data){
                var loadModal = function(){
                    TemplateLoader.load(modal).then(function(){
                            $scope.modals[modal].show = true;
                            if(JV.Person && JV.Person.Global){
                                JV.Person.Global.grid.removeLoadingState();
                            }
                    });
                }
                if(modal =='duplicateCandidates'){
                    loadModal();
                }else{
                    fetchFilters().then(function(response){
                        if(response){
                            setupFormTemplateConfig(modal,data);
                            loadModal();
                        }
                    });
                }
            };

            $scope.hideModalsAndRefresh = function(){
                $scope.hideModals();
                if($scope.CandidateListPage){
                    refreshGrid();
                }
            };

            //Used to hide all the modals on the page
            $scope.hideModals = function(){
                angular.forEach($scope.modals, function(val, key) {
                     $scope.modals[key].show = false;
                });
                if($scope.CandidateListPage && JV.Person){
                    JV.Person.resetValues();
                }
                
            };
            $scope.templates = TemplateLoader.register({
                move: '/jhire/modules/candidates/modals/moveCandidate.html',
                duplicateCandidates:'/jhire/modules/candidates/modals/duplicateCandidates.html'
            });

            var removeLoadingState = function(){
                if($scope.CandidateListPage && JV.Person){
                    JV.Person.Global.grid.removeLoadingState();
                }else{
                   $scope.flags.loading = false;
                }
            };

            //Move Candidate 
            $scope.moveCandidate = function(data){

                $scope.hideModals();
                if(JV.Person && JV.Person.Global){
                    JV.Person.Global.grid.showLoadingState();
                }
                if(!data.selectedReqEId || $.isEmptyObject(data.selectedReqEId)){
                    return false;
                }
                var destinationJobId = data.selectedReqEId;
                //Source jobId can be 0 for general applications
                var sourceJobId,applicationList;

                 
                if($scope.CandidateDetailsPage){
                    //Details Page
                    sourceJobId = $scope.appDetails.application.job.EId||0;
                    applicationList = [$scope.applicationId];
                }else{
                    if(JV.Person){
                        //list page
                        sourceJobId = JV.Person.getUniqueSelectedApplicationJobIds()[0];
                        applicationList = JV.Person.getSelectedAppIds();
                    }else{
                        sourceJobId = $scope.modalData.reqId;
                        applicationList = $scope.modalData.appIds;
                    }
                }

                if($scope.properties.enableMoveCandidate) {
                         var bulk = true;
                         $scope.modalData.destinationJobId = destinationJobId,
                         $scope.modalData.CandidateListPage = $scope.CandidateListPage
                         //data.appId = args.data.appIds;
                         $rootScope.$broadcast('showMoveAcrossWorkflowsModal',bulk, $scope.modalData);
                }
                else
                {
                var postData = {
                    destinationJobId: destinationJobId,
                    sourceJobId: sourceJobId,
                    data: applicationList
                };
                var applicationListUrl = jvUrls.jhire+'/action/applications';
                $scope.flags.loading = true;
                jvCandidatesService.moveCandidate(postData,function(response){
                    $scope.flags.loading = false;
                    if(response && response.data && response.status === 200){
                        $scope.hideModals();

                        if(response.data && $rootScope.size(response.data.notmoved)>0){
                            showDuplicateModal(response.data);
                            return false;
                        }
                        if(applicationList.length =='1'){
                            $rootScope.$emit('MOVE_SINGLE_CANDIDATE_SUCCESS', true);
                        }else{
                            $rootScope.$emit('MOVE_MULTIPLE_CANDIDATE_SUCCESS', applicationList);
                        }
                        //redirection logic from old list page.
                        var toSearch = '';
                        if($scope.CandidateListPage){
                            if($window.location.href.indexOf('/candidates/search.html') === -1){
                                var CandidateListUrl = jvUrls.source+'/person/applicants.html?';
                                toSearch = 'updateFetch=true';
                                if(location.href.split(toSearch)[1]){
                                    //updateFetch=true already exists in the url
                                    location.reload();
                                }else{
                                    //add updatefetch=true
                                    CandidateListUrl += toSearch;
                                    location.replace(CandidateListUrl);
                                }
                               var confirmationText = (applicationList.length =='1') ? i18n['JV_MOVECANDIDATE_CONTROLLER_1_CANDIDATE_WAS_SUCCESFULLY_MOVED'] : i18n['JV_MOVECANDIDATE_CONTROLLER__0_CANDIDATES_WERE_SUCCESFULLY_MOVED'].format(applicationList.length);
                                JV.Person.Global.grid.removeLoadingState();
                                JV.Util.showMessage(confirmationText);
                            }
                        }else{
                            //We need to reload the page with readMode=0
                            var CandidateDetailsUrl = jvHireUrlService.getApplicationDetailsUrl($scope.applicationId, true);
                            toSearch = 'readMode=0';
                            if(location.href.split(toSearch)[1]){
                                //readMode=0 already exists in the url
                                location.reload();
                            }else{
                                location.replace(CandidateDetailsUrl);
                            }
                        }
                    }else{
                        //fail 
                        removeLoadingState();
                    }
                });
}
            };
        }
]);